import * as React from "react";
import { DeleteOutlined } from "@ant-design/icons";
import { BsFuncParams } from "src/businessServices";
import { DropdownChildButton } from "src/components/buttons/DropdownChildButton";
import { Modal } from "antd";
import { observer } from "mobx-react-lite";

export const MCFuncTest: React.FC<BsFuncParams> = observer((props) => {
  const { name, info, entities } = props;
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <DropdownChildButton
        icon={<DeleteOutlined />}
        onClick={() => setOpen(true)}
      >
        Тестовая функция®
      </DropdownChildButton>
      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        title="Test function demo"
      >
        <div>Name: {name}</div>
        <div>Object: {info.objectId}</div>
        <div>Selected entities count: {entities.selected.length}</div>
      </Modal>
    </>
  );
});
